// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"145":"f284f596","156":"076a694b","157":"1150fae0","265":"b47fbfd7","363":"578497ee","428":"4173cc65","453":"99c20711","494":"8b984883","604":"29b61ee9","724":"d94a8ead","752":"a03c9977","807":"dcbfb565","876":"37c78f57","912":"7b4519ed","969":"b0de47be"}[chunkId] + ".chunk.js";
};